import Text from '@deprecated-ui/common/Text';
import Flex from '@deprecated-ui/common/Flex';
import { useSelector } from 'react-redux';
import { selectors } from 'lib/entities/profile';
import { Community, Fee } from '../../../../@types/community';
import { FieldsetWrapper } from '../styled';

interface Props {
  fee: Fee;
  community: Community;
  communityFee?: Fee;
  withProfile?: boolean;
}

function Fieldset({ fee, community, communityFee, withProfile }: Props) {
  const {
    data: { phone, username },
  } = useSelector(selectors);

  return (
    <FieldsetWrapper>
      {/* @ts-expect-error */}
      <Flex justify="space-between" align="flex-start" mb="12px">
        <span>Komunitas</span>
        <strong>{community?.name}</strong>
      </Flex>
      {withProfile && (
        <>
          {/* @ts-expect-error */}
          <Flex justify="space-between" align="flex-start" mb="12px">
            <span>Stockbit Username</span>
            <strong>{username}</strong>
          </Flex>
          {/* @ts-expect-error */}
          <Flex justify="space-between" align="flex-start" mb="12px">
            <span>No. HP</span>
            <strong>{phone}</strong>
          </Flex>
        </>
      )}
      {/* @ts-expect-error */}
      <Flex justify="space-between" align="flex-start" mb="12px">
        <span>Total Fee Beli</span>
        <strong>
          {communityFee ? (
            <>
              <span className="grey line-through">{fee?.total_buy || 0}%</span>
              {' → '}
              <>{`${communityFee?.total_buy || 0}%`}</>
            </>
          ) : (
            <>{`${fee?.total_buy || 0}%`}</>
          )}
        </strong>
      </Flex>
      <Flex
        justify="space-between"
        align="flex-start"
        // @ts-expect-error
        mb={communityFee ? '12px' : '0px'}
      >
        <span>Total Fee Jual</span>
        <strong>
          {communityFee ? (
            <>
              <span className="grey line-through">{fee?.total_sell || 0}%</span>
              {' → '}
              {`${communityFee?.total_sell || 0}%`}
            </>
          ) : (
            <>{`${fee?.total_sell || 0}%`}</>
          )}
        </strong>
      </Flex>
      {communityFee ? (
        <Text
          as="span"
          size="12px"
          height="16px"
          color="rgba(150, 150, 150, 1)"
        >
          Fee baru berlaku efektif satu hari setelah aktivasi kode.
        </Text>
      ) : null}
    </FieldsetWrapper>
  );
}

export default Fieldset;
